import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ViewOrder from './ViewOrder';

interface OrderReceivedViewProps {
    basePath?: string;
    featureFlags?: {
        orderHistoryTrackingEnabled?: boolean;
    };
}

const normalizeBasePath = (basePath?: string): string => {
    const trimmed = String(basePath || '/my-account').trim();
    if (!trimmed || trimmed === '/') {
        return '/my-account';
    }

    return `/${trimmed.replace(/^\/+|\/+$/g, '')}`;
};

const OrderReceivedView: React.FC<OrderReceivedViewProps> = ({
    basePath = '/my-account',
    featureFlags,
}) => (
    <BrowserRouter basename={normalizeBasePath(basePath)}>
        <Routes>
            <Route
                path="/order-received/:orderId"
                element={<ViewOrder featureFlags={featureFlags ?? {}} displayMode="order-received" />}
            />
        </Routes>
    </BrowserRouter>
);

export default OrderReceivedView;
